import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: state => ({
        currentLanguage: state.currentLanguage
    })
});

//console.log(router)

export default new Vuex.Store({
    state: {
        currentLanguage: 'sl'
    },
    mutations: {
        setLanguage (state, data) {
            state.currentLanguage = data;
        }
    },
    getters: {
        currentLanguage (state) {
            return state.currentLanguage;
        }
    },
    plugins: [vuexLocal.plugin]
});